export default "__VITE_ASSET__CjElKPQ9__"